import { useState } from 'react';
import { FaUpload, FaTimes } from 'react-icons/fa';
import { uploadImage } from '../../lib/adminApi';

// Pojedyncze zdjęcie: upload + podgląd + usunięcie
export function ImageField({ label, value, onChange, folder = 'uploads' }) {
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const url = await uploadImage(file, folder);
      onChange(url);
    } catch (err) {
      alert('Błąd wysyłania zdjęcia: ' + err.message);
    } finally {
      setBusy(false);
      e.target.value = '';
    }
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={value} alt="" className="w-24 h-24 object-cover rounded-lg border border-gray-200" />
            <button type="button" onClick={() => onChange(null)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center shadow">
              <FaTimes className="w-3 h-3" />
            </button>
          </div>
        ) : (
          <div className="w-24 h-24 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-xs">brak</div>
        )}
        <label className="cursor-pointer inline-flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm text-gray-700">
          <FaUpload className="w-4 h-4" />
          {busy ? 'Wysyłanie...' : 'Wybierz zdjęcie'}
          <input type="file" accept="image/*" className="hidden" onChange={handleFile} disabled={busy} />
        </label>
      </div>
    </div>
  );
}

// Wiele zdjęć: upload wielu + podgląd w siatce + usuwanie
export function MultiImageField({ label, value = [], onChange, folder = 'uploads' }) {
  const [busy, setBusy] = useState(false);

  const handleFiles = async (e) => {
    const files = [...(e.target.files || [])];
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (const f of files) urls.push(await uploadImage(f, folder));
      onChange([...(value || []), ...urls]);
    } catch (err) {
      alert('Błąd wysyłania zdjęć: ' + err.message);
    } finally {
      setBusy(false);
      e.target.value = '';
    }
  };

  const removeAt = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label} <span className="text-gray-400">({value.length})</span></label>}
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-2 mb-2">
        {value.map((url, i) => (
          <div key={i} className="relative group">
            <img src={url} alt="" className="w-full h-20 object-cover rounded border border-gray-200" />
            <button type="button" onClick={() => removeAt(i)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <FaTimes className="w-2.5 h-2.5" />
            </button>
          </div>
        ))}
      </div>
      <label className="cursor-pointer inline-flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-sm text-gray-700">
        <FaUpload className="w-4 h-4" />
        {busy ? 'Wysyłanie...' : 'Dodaj zdjęcia'}
        <input type="file" accept="image/*" multiple className="hidden" onChange={handleFiles} disabled={busy} />
      </label>
    </div>
  );
}
